import * as React from 'react';

// Components
import NotesGrid from './NotesGrid'
import NotesMobile from './NotesMobile'

import {
  HTTPHeaders
} from "../../interfaces";

import {
  DateRange,
  RequestNote
} from '../../models';

import {
  API_URL
} from '../../global';

// Auth0 user hooks 
import { useAuth0User } from '../../hooks/UseAuth0User';

// Responsive hooks
import { useResponsive } from '../../hooks/UseResponsive';

interface NotesProps {
  dateRange: DateRange;
}

const Notes: React.FC<NotesProps> = (props) => {

  const { getAccessToken } = useAuth0User();
  const { isMobile } = useResponsive();

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [rows, setRows] = React.useState<Array<RequestNote>>([]);

  // #region Methods

  /*
 * Fetch request notes based upon filter
 */
  const fetchNotes = async () => {

    setIsLoading(true);

    // Auth0 API token
    const accessToken = await getAccessToken();

    const headers: HTTPHeaders = {};
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
    headers['Authorization'] = `Bearer ${accessToken}`;

    // Always show current date forward
    const params = new URLSearchParams();
    if (props.dateRange !== undefined) {
      if (props.dateRange.startDate) {
        params.append('startDate', props.dateRange.startDate);
      }
      if (props.dateRange.endDate) {
        params.append('endDate', props.dateRange.endDate);
      }
    }

    const url = new URL(`${API_URL}/v1/requests/requestnotes`);
    url.search = params.toString();

    await fetch(url.toString(), {
      method: 'GET',
      cache: 'no-cache',
      headers: headers,
      mode: 'cors'
    })
      .then((response) => {
        if (!response.ok) {
          setIsLoading(false);
          throw new Error('Request notes not retrieved');
        }
        return response.json()
      })
      .then((gridData: Array<RequestNote>) => {
        setRows(gridData);
        setIsLoading(false);
      })
      .catch(err => {
        setIsLoading(false);
      });
  }

  // #endregion

  // #region Event handlers

  React.useEffect(() => {
    if (props.dateRange.startDate && props.dateRange.endDate) {
      fetchNotes();
    } else {
      setRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateRange.startDate, props.dateRange.endDate]);

  // #endregion

  return (
    <>
      {!isMobile &&
        <NotesGrid
          isLoading={isLoading}
          rows={rows}
        />
      }
      {isMobile &&
        <NotesMobile
          rows={rows}
        />
      }
    </>
  );

}

export default Notes;